export const customerSpecificDataFields = `
  customerSpecificData {
    key
    value
  }
`;
